export enum PrescriptionStatusType {
  NOT_COLLECTED,
  COLLECTED,
  NOT_IN_RECIPE,
}

export const mapStringToPrescriptionStatusTypeEnum = (type?: string) => {
  switch (type && type.toUpperCase()) {
    case "COLLECTED":
      return PrescriptionStatusType.COLLECTED;
    case "NOT_COLLECTED":
      return PrescriptionStatusType.NOT_COLLECTED;
    case "NOT_IN_RECIPE":
    default:
      return PrescriptionStatusType.NOT_IN_RECIPE;
  }
};
